import { DEFAULT_MEDIA_QUERY_PLATFORMS, COMPONENT_STATES, COMPONENT_TYPE as TYPE } from 'common/constants';
import { generateElementId, generateNodeId } from 'common/utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Content/Content';

export const CONTENT = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.CONTENT,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: CONTENT.displayName,
					selectable: false,
					draggable: false,
					expandable: true,
					expanded: true,
				},
				nodeProps: {
					id: generateNodeId(_id, CONTENT.displayName),
				},
				componentProps: {
					styles: {
						[COMPONENT_STATES.DEFAULT]: {
							[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
						},
					},
					other: {},
				},
			},
			children: [],
		},
	};
};

CONTENT.displayName = 'Content';
